// Ce que l'écran de Radar mesure (issue #193) : les écrans ouverts et les
// erreurs JavaScript, ce que le serveur ne voit pas. Tout part vers
// `POST /api/telemetrie`, jamais vers PostHog directement : le serveur tient
// la clé, la liste blanche et le débit (src/web/telemetrie.ts).
//
// La VISITE relie les pas d'une inscription faits avant que le compte existe
// à ceux d'après : un identifiant tiré au hasard, gardé le temps de l'onglet
// (sessionStorage), envoyé avec chaque appel à l'API par `api()`. Il ne
// survit pas à la fermeture de l'onglet et ne suit personne d'une visite à
// l'autre. Le compte, lui, est reconnu par sa session, côté serveur.
//
// La console n'envoie rien : `mesurer` ne part qu'en formule Radar.

let formuleMesuree = false

export function activerMesure(radar: boolean): void {
  formuleMesuree = radar
}

let visiteMemoire: string | null = null

export function visite(): string {
  try {
    const v = sessionStorage.getItem('radar.visite')
    if (v) return v
    const neuve = crypto.randomUUID()
    sessionStorage.setItem('radar.visite', neuve)
    return neuve
  } catch {
    // Stockage refusé (navigation privée stricte) : une visite par chargement.
    visiteMemoire ??= crypto.randomUUID()
    return visiteMemoire
  }
}

export function mesurer(e: 'radar_ecran' | 'radar_erreur_js' | 'radar_clic', p: Record<string, string | number | boolean> = {}): void {
  // Global Privacy Control : rien ne part (page de confidentialité). Le serveur
  // lit le même signal dans l'en-tête `Sec-GPC` pour ses propres events.
  if (!formuleMesuree || (navigator as { globalPrivacyControl?: boolean }).globalPrivacyControl === true) return
  const corps = JSON.stringify({ e, p, v: visite() })
  try {
    if (navigator.sendBeacon?.('/api/telemetrie', corps)) return
  } catch {
    // Repli ci-dessous.
  }
  fetch('/api/telemetrie', { method: 'POST', body: corps, keepalive: true }).catch(() => {})
}

let dernierEcran = ''

/** Un écran ouvert, une fois par changement : un rendu de plus ne recompte pas. */
export function mesurerEcran(ecran: string): void {
  if (!formuleMesuree || ecran === dernierEcran) return
  dernierEcran = ecran
  mesurer('radar_ecran', { ecran })
}

let erreursEnvoyees = 0

/** Les exceptions non rattrapées, cinq par chargement au plus, comme l'extension :
 *  une boucle d'erreurs ne doit pas remplir les tableaux. Le message seul, coupé. */
export function installerCaptureErreurs(): void {
  const envoyer = (message: string) => {
    if (erreursEnvoyees >= 5) return
    erreursEnvoyees++
    mesurer('radar_erreur_js', { message: message.slice(0, 120), ecran: dernierEcran })
  }
  window.addEventListener('error', (ev) => envoyer(String(ev.message || ev.error || 'erreur')))
  window.addEventListener('unhandledrejection', (ev) => envoyer(String((ev.reason as any)?.message ?? ev.reason ?? 'rejet')))
}
